import React from 'react';
import classes from "./ContactUs.module.css";
import Header from '../components/Header';
import BottomNavbar from '../components/BottomNavbar';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaPhone, FaEnvelope } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ContactUs = () => {
    const navigate = useNavigate();

    const {t}=useTranslation();

    return (
        <>
            <Header />

            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate(-1);
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("23")}</h2>


                </div>

                <p className={classes.contact_text}>
                    {t("25")}
                </p>

                <a href='tel:***' className={classes.contact_btn}>
                    <FaPhone className={classes.mail_icon} /> ****
                </a>
                <a href="mailto:****" className={classes.contact_btn} style={{ marginTop: "-6px" }}>
                    <FaEnvelope className={classes.mail_icon} /> ****
                </a>
            </div>
            <BottomNavbar active={4} />
        </>
    )
}

export default ContactUs;